import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class ServiceFilterEntity {
  id?: number
  region?: RegionMiniEntity
  page?: number
  limit?: number
  searchWord?: string
}
